// VatFilingStatusPanel.jsx
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Badge, Button, Input, Modal, Space, Table, Tag } from "antd";
import { fetchVatFilingStatus, markQuarterFiled } from "./vatFilingSlice";


const STATUS_COLOR = { filed: "success", due: "warning", overdue: "error", upcoming: "default" };

const VatFilingStatusPanel = () => {
  const dispatch   = useDispatch();
  const { quarters, saving } = useSelector((s) => s.vatFiling);
  console.log('quaters:::',quarters);
  const [modal, setModal]   = useState(null); // { id, label }
  const [ref, setRef]       = useState("");
  const [notes, setNotes]   = useState("");

  const handleMark = async () => {
    await dispatch(markQuarterFiled({ id: modal.id, reference_no: ref, notes }));
    dispatch(fetchVatFilingStatus());
    setModal(null); setRef(""); setNotes("");
  };

  const columns = [
    { title: "Quarter", dataIndex: "label" },
    { title: "Period",  dataIndex: "period" },
    { title: "Deadline", dataIndex: "deadlineLabel" },
    {
      title: "Status",
      dataIndex: "status",
      render: (s) => <Tag color={STATUS_COLOR[s]}>{s?.toUpperCase()}</Tag>,
    },
    { title: "Filed date",  dataIndex: "filedDate",   render: (v) => v || "—" },
    { title: "Reference",   dataIndex: "referenceNo", render: (v) => v || "—" },
    {
      title: "Action",
      render: (_, row) =>
  row.status !== "filed" && row.status !== "upcoming" ? (
  <Button
    size="small"
    type="primary"
    danger={row.status === "overdue"}
    onClick={() => setModal({ id: row.id, label: row.label })}
  >
    Mark as filed
  </Button>
) : row.status === "filed" ? "✅ Filed" : "—"
    },
  ];

  return (
    <>
      <Table
        rowKey="quarterNum"
        columns={columns}
        dataSource={quarters}
        pagination={false}
        size="small"
      />
      <Modal
        open={!!modal}
        title={`Mark ${modal?.label} as filed`}
        onCancel={() => setModal(null)}
        onOk={handleMark}
        confirmLoading={saving}
        okText="Confirm filing"
      >
        <Space direction="vertical" style={{ width: "100%" }}>
          <Input placeholder="Reference / TRN number" value={ref}
            onChange={(e) => setRef(e.target.value)} />
          <Input.TextArea rows={3} placeholder="Notes (optional)" value={notes}
            onChange={(e) => setNotes(e.target.value)} />
        </Space>
      </Modal>
    </>
  );
};

export default VatFilingStatusPanel;